module.exports = __webpack_public_path__ + "static/media/Inter-LightItalic-BETA.de358027.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Inter/Inter-LightItalic-BETA.woff2
// module id = 696
// module chunks = 21